const HOTEL_CATEGORY = 'hotel';
const REGION_CATEGORY = 'region';
const LOCATION_CATEGORY = 'location';
const LOCATION_PLACES_CATEGORY = 'location_places';

module.exports = {
    HOTEL_CATEGORY,
    REGION_CATEGORY,
    LOCATION_CATEGORY,
    LOCATION_PLACES_CATEGORY
};